'use client';
import * as React from 'react';

const GridRootPropsContext = React.createContext<unknown>(undefined);

export { GridRootPropsContext };
